import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Support hash-based auth for cast receiver (Presentation API)
  if (!auth.isAuthenticated()) {
    const hash = window.location.hash;
    if (hash) {
      const params = new URLSearchParams(hash.slice(1));
      const token = params.get('token');
      const tenantId = params.get('tenantId');
      const user = params.get('user');
      if (token && tenantId && user) {
        try {
          auth.setAuth(token, tenantId, JSON.parse(decodeURIComponent(user)));
        } catch { /* ignore parse errors */ }
      }
    }
  }

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
